import { Axios } from "../../axios.interceptor";

const h = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getTags   = (params, token) => Axios.get("/api/v1/admin/blog/tags", { params, ...h(token) });
export const createTag = (data, token)   => Axios.post("/api/v1/admin/blog/tags", data, h(token));
export const updateTag = (id, d, token)  => Axios.put(`/api/v1/admin/blog/tags/${id}`, d, h(token));
export const deleteTag = (id, token)     => Axios.delete(`/api/v1/admin/blog/tags/${id}`, h(token));
